import React, { useState, useEffect } from "react";
import { NavMenu } from "components/organisms/NavMenu";
import { Header } from "components/organisms/Header";
import withInteractionData from "hoc/withInteractionData";
import withFeatureFlags from "hoc/withFeatureFlags";
import JsaNotification from "components/organisms/JsaNotification/JsaNotification";
import { useLocation } from "react-router-dom";
import { HedisPopUps } from "components/molecules/HedisPopUps/HedisPopUps";
import { Box, Container } from "@mui/material";
import withMemberData from "hoc/withMemberData";
import { MemberPortalConfigProvider } from "contexts/MemberPortalConfigContext";
import { NoticeBanners } from "components/organisms/NoticeBanners/NoticeBanners";

const SHOW_HEDIS_CAMPAIGNS_POP_UPS_FEATURE_FLAG = "show-hedis-campaigns-popups";
const jsaRoute = "/jsa-appointment-request";
const messageCenterRoute = "/message-center";

export const Layout = (props) => {
  const [displayJsa, setDisplayJsa] = useState(true);

  const location = useLocation();

  useEffect(() => {
    if (location?.pathname == jsaRoute) {
      setDisplayJsa(false);
    } else {
      setDisplayJsa(true);
    }
  }, [location?.pathname]);

  return (
    <div className="main-content">
      <MemberPortalConfigProvider member={props.member}>
        <Header {...props} />
        <NavMenu {...props} />
        <Container>
          <NoticeBanners paddingTop={4} />
          <Box rowGap={2}>
            <HedisPopUps />
            {displayJsa && <JsaNotification member={props.member} />}
          </Box>
          {props.children}
        </Container>
      </MemberPortalConfigProvider>
    </div>
  );
};

export default withFeatureFlags(withInteractionData(withMemberData(Layout)));
